import controller from './reviewing.controller';
import '../student.less';

export default {
  controller,
  template: require('./reviewing.html')
};



// WEBPACK FOOTER //
// src/app/components/student/reviewing/reviewing.component.ts